module.exports = __webpack_public_path__ + "media/images/pdf-f4275a072e5ce9f1e05c8002a5447b48.svg";